import { type FC, type ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * Shared `t.rich(...)` `highlight` renderer for a dynamic name inside a toast/notification
 * message: bold, truncated, with a tooltip so the full value stays recoverable on hover even
 * when it clips. `chunks` is the interpolated value itself, so the tooltip needs no separate
 * variable threaded in from the caller.
 */
export const ToastHighlight: FC<{ chunks: ReactNode; className?: string; leading?: boolean }> = ({
  chunks,
  className,
  leading = false,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className={cn('inline-block truncate font-bold', leading ? 'mr-1' : 'mx-1', className)}>{chunks}</span>
    </TooltipTrigger>
    <TooltipPortal>
      {/* The toast viewport is z-100 (components/ui/toast.tsx); this must draw above it, or a
          real hover would show the tooltip rendered but hidden behind the toast box. */}
      <TooltipContent className="z-101 max-w-64 break-all">{chunks}</TooltipContent>
    </TooltipPortal>
  </Tooltip>
);
